import { useState } from 'react';

export const useSectionNavigation = (
    currentSection: number,
    totalSections: number,
    sections: string[],
    setCurrentSection: (section: number) => void,
    setHasFormErrors: (hasErrors: boolean) => void,
    scrollToTop: () => void,
    handleUserActivity: (action: string) => void
) => {
    const [isNavigating, setIsNavigating] = useState(false);

     const handleSectionChangeForward = () => {
        const nextSectionIndex = Math.min(totalSections - 1, currentSection + 1);
        handleUserActivity(
        `Move to next section ${
            nextSectionIndex === 0
            ? "General Information"
            : sections[nextSectionIndex - 1]
        }`
        );

        setIsNavigating(true);
        setTimeout(() => {
        setCurrentSection(nextSectionIndex);
        scrollToTop();
        setIsNavigating(false);
        }, 300);
    };

    const handleSectionChangeBackward = () => {
        const prevSectionIndex = Math.max(0, currentSection - 1);
        handleUserActivity(
        `Move to previous section ${
            prevSectionIndex === 0
            ? "General Information"
            : sections[prevSectionIndex - 1]
        }`
        );

        setIsNavigating(true);
        setTimeout(() => {
        setHasFormErrors(false);
        setCurrentSection(prevSectionIndex);
        scrollToTop();
        setIsNavigating(false);
        }, 300);
    };

    const handleSidebarItemClick = (sectionIndex: number) => {
        if (sectionIndex === currentSection) return;

        handleUserActivity(`Navigate to section ${sectionIndex}`);

        setIsNavigating(true);
        setTimeout(() => {
        setCurrentSection(sectionIndex);
        scrollToTop();
        setIsNavigating(false);
        }, 300);
    };

    return {
        isNavigating,
        handleSectionChangeForward,
        handleSectionChangeBackward,
        handleSidebarItemClick
    }
}
